/* eslint-disable no-nested-ternary */
export const paxDefault = {
  Port: 10101,
  logLevel: 'DEBUG',
  logSentryDuration: 0,
  logTarget: 'FILE',
  SSLEnable: true,
  Production: true,

  deviceIp: '',
  devicePort: '',
  deviceCommType: 'TCP',
  deviceTimeout: '',
};

export const paxFields = {
  deviceIp: {
    id: 'deviceIp',
    title: 'Device IP',
    type: 'text',
    validate: (val) =>
      val?.length
        ? val?.match(/[^\da-zA-Z.-]/g)?.length
          ? 'Invalid device IP.'
          : null
        : 'Device IP is required.',
  },
  devicePort: {
    id: 'devicePort',
    title: 'Device Port',
    type: 'text',
    validate: (val) =>
      val?.length
        ? val?.match(/[^\d]/g)?.length
          ? 'Invalid Device Port'
          : null
        : 'Device Port is required.',
  },
  deviceCommType: {
    id: 'deviceCommType',
    title: 'Device Communications type',
    options: [
      { name: 'TCP', value: 'TCP' },
      { name: 'HTTP', value: 'HTTP' },
    ],
  },
  deviceTimeout: {
    id: 'deviceTimeout',
    title: 'Device Timeout',
    type: 'text',
    validate: (val) => {
      if (val < 0) return 'Timeout must be positive';
      if (val?.length === 0) return 'Cannot be empty';
      return null;
    },
  },
};
